import React from 'react';
import {RoundButton} from '@cloudaper/react';

const AppBack = props => {
  return (
    <div className="appBack">
      <RoundButton
        className="appBackButton"
        iconName="arrow-left"
        onClick={props.onClick}
      />
    </div>
  );
};

export default AppBack;
